import { useLayoutEffect, useContext } from 'react';
import { AuthContext } from '../contexts/AuthContext';

/**
 * index.html may set documentElement.visibility = 'hidden' for app routes and
 * for '/' when authToken exists, to avoid flashing pre-rendered marketing HTML.
 * Only reveal after auth bootstrap finishes so we don't flash the wrong route.
 */
const AuthVisibilityBootstrap = () => {
  const { isInitializing } = useContext(AuthContext);

  useLayoutEffect(() => {
    if (!isInitializing) {
      document.documentElement.style.visibility = '';
    }
  }, [isInitializing]);

  return null;
};

export default AuthVisibilityBootstrap;
